import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Checkbox, ComputedBox, Loader} from '@guestapp/old-ui-kit';
import {Fields as FieldGroupContent} from 'components/FieldsGroup/styled';

export const Wrapper = styled.div`
  display: grid;
  grid-column-gap: 40px;
  grid-template-rows: repeat(1, auto);
  text-align: center;
  width: 100%;
  position: relative;
  grid-template-columns: 1px [content-start] 1fr [content-end] 1px;

  @media (max-width: ${DEVICE.laptop}) {
    max-width: 463px;
    grid-column: unset;

    ${FieldGroupContent} {
      grid-column: unset;
      grid-template-columns: unset;
    }
  }

  @media (max-width: ${DEVICE.laptop}) {
    grid-column-gap: 10px;
  }

  ${FieldGroupContent} {
    grid-column: content-start / content-end;
    grid-template-columns: subgrid;
    align-self: stretch;
  }
`;

export const AcceptWarning = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 24px;
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontSecondary
      : props.theme.colors.$p10};

  grid-column: 1 / -1;

  & a {
    font-size: inherit;
    font-weight: 700;
  }
`;

export const LinkInText = styled.span`
  font-weight: bold;
  color: ${({theme}) => theme.colors.buttons.textButton};
  cursor: pointer;
`;

export const PleaseSignModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  height: 400px;

  .title {
    font-size: 24px;
  }

  .text {
    font-size: 18px;
  }
`;

type DesktopSignAreaContainerProps = {
  $disabled: boolean;
  $required?: boolean;
};

export const DesktopSignArea = styled.div`
  width: 300px;
  height: 179px;

  border-radius: 5px;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DesktopSignAreaContainer = styled.div<DesktopSignAreaContainerProps>`
  height: 200px;
  background: #f4f6f9;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 auto 12px;
  border: 2px solid #e6e8ec;
  max-width: 365px;
  width: 100%;
  grid-column: content-start / content-end;
  grid-template-columns: subgrid;
  align-self: stretch;

  @media only screen and (min-width: ${DEVICE.laptop}) {
    width: 300px;
  }

  ${props =>
    props.$disabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
      ${DesktopSignArea} {
        border: 2px dashed #b1b5c4;
      }
    `}

  ${props =>
    props.$required &&
    css`
      border: 1px solid #f84b7a;
    `}
`;

export const SignButton = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: ${({theme}) => theme.colors.buttons.textButton};
  grid-column: content-start / content-end;
  grid-template-columns: subgrid;

  @media (min-width: ${DEVICE.laptop}) {
    color: ${({theme}) => theme.colors.buttons.textButton};
  }
`;

export const DesktopSignatureImage = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
export const RepeatSignatureButton = styled.span`
  margin-bottom: 36px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: ${({theme}) => theme.colors.buttons.textButton};
  cursor: pointer;

  @media (min-width: ${DEVICE.laptop}) {
    margin-bottom: 36px;
  }
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 48px;
  width: 100%;

  @media (min-width: ${DEVICE.laptop}) {
    width: auto;
  }
`;

export const SubmitButton = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 365px;
  grid-column: content-start / content-end;
  grid-template-columns: subgrid;
  align-self: stretch;

  & .submit-btn {
    width: 100%;
    margin: 0 auto;
  }
`;

export const ErrorMessage = styled.div`
  font-family: inherit;
  text-align: center;
  color: #f84b7a;
  font-size: 11px;
  margin-bottom: 15px;
  grid-column: content-start / content-end;
`;

export const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
`;

export const StyledComputedBox = styled(ComputedBox)`
  padding-top: 20px;
  max-width: 293px;

  @media (min-width: ${DEVICE.laptop}) {
    padding-top: 16px;
  }
`;

export const StyledLoader = styled(Loader)`
  margin: 10px auto 35px;
`;
